"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M6.84375 3.46316C6.54726 3.46316 6.30691 3.70351 6.30691 4C6.30691 4.29649 6.54726 4.53684 6.84375 4.53684V3.46316ZM19.8438 4H20.3806C20.3806 3.70351 20.1402 3.46316 19.8438 3.46316V4ZM19.3069 10C19.3069 10.2965 19.5473 10.5368 19.8438 10.5368C20.1402 10.5368 20.3806 10.2965 20.3806 10H19.3069ZM6.84375 4.53684H19.8438V3.46316H6.84375V4.53684ZM19.3069 4V10H20.3806V4H19.3069Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1 9.84204L6.84204 4",
      stroke: "currentColor",
      strokeWidth: "1.07368"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14 15.842L19.842 10",
      stroke: "currentColor",
      strokeWidth: "1.07368"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M14.1562 9.84204L19.5 4.49829",
      stroke: "currentColor",
      strokeWidth: "1.07368"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1 9.84204H14V15.842H1V9.84204Z",
      stroke: "currentColor",
      strokeWidth: "1.07368",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M3 11.842H12V13.842H3V11.842Z",
      stroke: "currentColor",
      strokeWidth: "1.07368",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;